export default __webpack_public_path__ + "static/media/create-rampver-account-with-arrow.17984f22.png";